import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=7816ccba&scoped=true&"
import script from "./Access.vue?vue&type=script&lang=ts&"
export * from "./Access.vue?vue&type=script&lang=ts&"
import style0 from "./Access.vue?vue&type=style&index=0&id=7816ccba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7816ccba",
  null
  
)

export default component.exports